import { PageRouteBuilder } from "@common/route/page-route-builder";
import { MergeUsersPageComponent } from "./merge-users-page.component";

export const mergeUsersPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-merge-users-page", MergeUsersPageComponent)
    .requiresLogin()
    .atUrl("/tools/merge-users")
    .withTitle("Merge Users")
    .build();
